module.exports = __webpack_public_path__ + "img/unitStatus.62123c06.png";